import React, { Component } from 'react';
import $ from 'jquery'



class AuditIS extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

            $("#audit-is-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="audit-is">
            <h1>Audity IS – kontrola legálnosti SW:</h1>
            <span>

            Výstupem z konkrétní nezávislé analýzy IS jsou přesné a systematické data pro řízení a rozhodovací procesy v oblasti využívání informačních technologií ve společnosti. Předpokladem úspěšného a přesného auditu IS je aktivní spolupráce s vedením firmy, IT složkami podniku i zodpovědnými pracovníky jednotlivých útvarů podniku.
<br/><br/>
                <h2>Předmět auditu:</h2>
                <li>Analýza současného stavu:</li>
                    <ul>
                                 <li>Sítě, zatížení, servery</li>
                                 <li>Hardware, periférie</li>
                                 <li>Licenční software</li>
                                 <li>Aplikační software</li>
                                 <li>Problémy, požadavky</li>
                                 <li>Úroveň využívání</li>
                                 <li>Archivace dat</li>
                                 <li>Bezpečnost dat</li>
                    </ul>
           <li>Návrhy realizace</li>
                    <ul>
                            <li>Optimalizace sítě (sítí)</li>
                            <li>Varianty dalšího rozvoje a způsoby pořizování hardware a síťových prvků</li>
                            <li>Politika licenčního software</li>
                           <li>Řešení centrální správy sítě</li>
                            <li>Komunikace - interní, externí (Internet, sdílení)</li>
                            <li>Bezpečnostní politika, archivační systém</li>
                            <li>Zabezpečení aktivních prvků sítě</li>
                    </ul>
<br/><br/>
            <h2>Přínosy auditu:</h2>
            <li>Minimalizace výdajů do IT a jejich koncepční návrhy obnovy</li>
            <li>Možné plánování investic i provozních nákladů</li>
            <li>Podpora investic, které jsou nutné pro rozvoj podniku a jeho konkurenceschopnost</li>
            <li>Efektivní využití nákladů na IT</li>
           <li>Možnost financování pořízení výpočetní techniky (plánování splátek leasingu apod.)</li>
<br/><br/>
            Softwarová kontrola slouží ke zpětnému dohledu instalovaného SW, jeho správného ošetření z hlediska licenčních smluv a jeho využitelnosti. Kontrolou získáte záruku právní nenapadnutelnosti v případě SW kontroly pověřeného orgánu. Softwarová kontrola v praxi znamená, že na veškerých instalovaných severech a klientských stanicích je přípravnou a skenovací fází diagnostického nástroje zjištěna přítomnost SW dle spouštěcích souborů a příslušných knihoven. Následně je provedena passportizace každého PC a serveru a případné narovnání licencí. Výsledkem auditu je výstupní formulář se stanovením legálnosti instalovaného SW. Softwarovou kontrolu můžeme provádět před převzetím správy sítě a posléze náhodně v průběhu roku. Pro přehlednost vývoje vedeme zákazníkovi evidence stavu IT. Takto získané informace jsou vždy tajné a naše firma s nimi nemůže nakládat jinak, než jak určuje uzavřená smlouva viz - ochrana dat. Služba je poskytována spolu s poradenskou činností pro nejefektivnější nákup a následné udržování spolehlivosti nabytého SW.

             </span>
        </div>


</div>
    );
  }
}

export default AuditIS;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/AuditIS.js